import React from 'react'
import PropTypes from 'prop-types'

import Box from 'components/_new/layout/Box/Box'


const MainSection = ({ children, id, className, alignCenter, withPaddingTop, withPaddingBottom }) => (
  <Box
    id={id}
    className={className}
    alignCenter={alignCenter}
    pt={withPaddingTop && '36'}
    pb={withPaddingBottom && '36'}
  >
    {children}
  </Box>
)


MainSection.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string,
  alignCenter: PropTypes.bool,
  withPaddingTop: PropTypes.bool,
  withPaddingBottom: PropTypes.bool,
}

MainSection.defaultProps = {
  withPaddingTop: true,
  withPaddingBottom: true,
}


export default MainSection
